import { httpClient } from './httpClient';

export type UserMetadata = Record<string, unknown>;

interface QueryOptions {
  signal?: AbortSignal;
}

const endpoint = '/api/v1/user-metadata';

export const userMetadataApi = {
  get: async (options?: QueryOptions): Promise<UserMetadata> =>
    (await httpClient.get<UserMetadata | undefined>(endpoint, options)) ?? {},

  set: (metadata: UserMetadata): Promise<void> => httpClient.put<void>(endpoint, metadata),
};
